export default __webpack_public_path__ + "assets/images/v-li-icon-fc7cd292.svg";